import CompleteIcon from "../ui/icons/CompleteIcon";
import { Text } from "../ui/text";
import ErrorIcon from "../ui/icons/ErrorIcon";
import CloseIcon from "../ui/icons/CloseIcon";

type Props = {
  type: "success" | "pending" | "fail" | "confirm" | "error";
  text: string;
  onSubmit?: () => void;
  onClose?: () => void;
};

const CustomToast = ({ type, text, onSubmit, onClose }: Props) => {
  const getStyle = (type: "success" | "pending" | "fail" | "confirm" | "error") => {
    if (type === "success") {
      return "border-primary-60 text-primary-20 bg-grey-100";
    }

    if (type === "pending") {
      return "border-[#EBAF15] text-[#926E10] pr-[64px]";
    }

    if (type === "confirm") {
      return "border-primary-60 text-primary-20 bg-grey-100 py-[12px]";
    }

    if (type === "fail") {
      return "border-red-60 text-red-20";
    }

    if (type === "error") {
      return "border-red-60 text-grey-100 bg-red-20 w-[472px]";
    }
  };

  const handleConfirmClick = () => {
    onSubmit?.();
  };

  return (
    <div
      className={`rounded-[4px] overflow-hidden flex gap-2 items-center border px-[16px] py-2 shadow-custom ${getStyle(type)}`}
    >
      {type === "success" && <CompleteIcon color={"#0AC4B2"} />}
      {type === "confirm" && <CompleteIcon color={"#0AC4B2"} />}
      {type === "fail" && <ErrorIcon />}
      {type === "error" && <ErrorIcon color={"#FFFFFF"} />}
      {type === "pending" && (
        <img
          src="/images/toast-spinner.gif"
          alt="spinner"
          width={40}
          height={40}
        />
      )}
      {type === "error" ? (
        <div className="flex items-center justify-between flex-1">
          <Text variant={"title-sm"} className="text-inherit" style={{ whiteSpace: "pre-line" }}>
            {text}
          </Text>
          {onClose && (
            <button className="ml-4 shrink-0" onClick={onClose}>
              <CloseIcon color={"#FFFFFF"} />
            </button>
          )}
        </div>
      ) : (
        <div className="flex gap-[24px] items-center">
          <Text variant={"title-sm"} className="text-inherit whitespace-nowrap">
            {text}
          </Text>
          {type === "confirm" && (
            <button className="w-[61px]" onClick={handleConfirmClick}>
              <Text variant={"title-sm"}>View Job</Text>
            </button>
          )}
          {type === "confirm" && (
            <button className="" onClick={handleConfirmClick}>
              <CloseIcon color={"#333333"} />
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default CustomToast;
